import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["option", "empty"]

  filter(event) {
    const query = event.target.value.trim().toLocaleLowerCase()
    let matches = 0
    this.optionTargets.forEach((option) => {
      option.hidden = !option.textContent.toLocaleLowerCase().includes(query)
      if (!option.hidden) matches += 1
    })
    this.emptyTarget.hidden = matches > 0
  }

  keydown(event) {
    if (event.key !== "Escape" || !this.element.open) return
    event.preventDefault()
    this.element.open = false
    this.element.querySelector("summary").focus()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) this.element.open = false
  }
}
